module.exports = __webpack_public_path__ + "static/media/blog-37-img4.96e86814.webp";